import {
  Component,
  OnDestroy,
  OnInit,
  Input,
  EventEmitter,
  AfterViewInit,
  OnChanges,
  SimpleChanges,
  Output,
} from "@angular/core";
import { Subject, Subscription } from "rxjs";
import { ValueRange } from "./value.range.model";
import { Constant } from "src/app/core/constant";
import { EventManager } from "src/app/core";
import { RELATION_OPERATIONS } from "./input-value-range.data";
import { debounceTime } from "rxjs/operators";
declare let $: any;
@Component({
  selector: "app-input-value-range",
  templateUrl: "./input-value-range.component.html",
  styleUrls: ["./input-value-range.component.scss"],
})
export class InputValueRangeComponent implements OnInit, OnChanges, OnDestroy {
  @Input() keyValue: string = "fee";
  @Input() title1: string = "Giá trị ban đầu";
  @Input() title2: string = "Giá trị kết thúc";
  @Input() titleValue: string = "Phí";
  @Input() unitValue: string = "%";
  @Input() data: any[] = [];
  @Input() isViewed: boolean = false;
  @Input() isValidated: boolean = false;
  @Input() typeCode: string = "";
  @Output() dataChange = new EventEmitter<any>();
  emitData$ = new Subject();
  Constant = Constant;
  beginOperators: any = ([] = []);
  endOperators: any = ([] = []);
  list: any[] = [];
  relationalOperators: any[] = RELATION_OPERATIONS;
  subscribe: Subscription | undefined;
  id: any;
  constructor(private eventManager: EventManager) {}
  ngOnInit() {
    this.setDefaultValueRange();
    this.subscribe = this.emitData$
      .pipe(debounceTime(500))
      .subscribe((event) => {
        return this.dataChange.emit(this.emitData());
      });
    this.emitData$.next(true);
  }
  ngOnDestroy() {
    this.subscribe && this.subscribe.unsubscribe();
  }
  setDefaultValueRange() {
    this.id = Math.floor(Math.random() * 10000);
    this.data = this.data || [];
    this.beginOperators = this.beginOperators || [];
    this.endOperators = this.endOperators || [];
    this.list = this.list || [];
    this.relationalOperators.forEach((operator) => {
      if (operator.direction === 0) {
        this.beginOperators.push(operator);
      } else {
        this.endOperators.push(operator);
      }
    });
  }
  ngOnChanges(simpleChanges: SimpleChanges) {
    const changes: any = simpleChanges;
    if (changes.data && changes.data.currentValue) {
      this.setDataEditForValueRange();
    }
  }

  setDataEditForValueRange() {
    this.list = [];
    if (!(this.data && this.data.length > 0)) {
      this.list.push(new ValueRange());
      this.list.push(new ValueRange());
      return;
    }
    this.data.forEach((item, index) => {
      const valueRange = new ValueRange(item);
      valueRange.keyValue = item[this.keyValue];
      this.list.push(valueRange);
    });
    if (this.list.length === 1) {
      this.addValueRange();
    }
  }
  addValueRange() {
    this.list = this.list || [];
    let valueRange = new ValueRange();
    valueRange.typeCode = this.typeCode;

    const lastedValueRange = this.list[this.list.length - 1];
    valueRange.beginValue = lastedValueRange.endValue;

    this.list.push(valueRange);

    const operator = this.relationalOperators.find(
      (ope) => ope.code === lastedValueRange.endOperatorCode,
    );
    if (!operator) {
      return;
    }
    valueRange.beginOperatorCode = operator.symmetry.code;
    valueRange.endOperatorCode = operator.code;
  }
  removeValueRange(index: any) {
    this.list.splice(index, 1);
    for (let i = index; i < this.list.length - 1; i++) {
      this.list[i + 1].beginValue = this.list[i].endValue;
    }
  }
  changeOperator(index: any) {
    const operator = this.relationalOperators.find(
      (ope) => ope.code === this.list[index].endOperatorCode,
    );
    if (this.list.length > index + 1) {
      this.list[index + 1].beginOperatorCode = operator.symmetry.code;
    }
    if (index + 1 === this.list.length - 1) {
      this.list[index + 1].endOperatorCode = operator.code;
    }
    this.emitData$.next(true);
  }
  changeEndValue(index?: any) {
    if (index != this.list.length - 1) {
      this.list[index + 1].beginValue = this.list[index].endValue;
    } 
    this.emitData$.next(true);
  }
  changeBeginValue(index) {
    if (index !== 0) {
      this.list[index - 1].endValue = this.list[index].beginValue
    }
    this.emitData$.next(true);
  }
  changeFee() {
    this.emitData$.next(true);
  }
  emitData() {
    let data = this.list;
    data = data.map((item, index) => {
      return {
        beginOperatorCode: item.beginOperatorCode || (index === 0 ? "<" : ""),
        endOperatorCode: item.endOperatorCode || "",
        beginValue: item.beginValue || 0,
        endValue: item.endValue,
        [this.keyValue]: item.keyValue,
        typeCode: this.typeCode ? this.typeCode : undefined,
      };
    });
    return data;
  }
}
